function getGoogleAuth() {
    if (window.document.readyState === 'complete') {
        return initGoogleAuth();
    } else {
        return new Promise(function (resolve, reject) {
            window.addEventListener('load', function () {
                initGoogleAuth().then(resolve, reject);
            });
        });
    }
}

async function initGoogleAuth() {
    await new Promise((resolve) => window.gapi.load('client', resolve));
    await window.gapi.client.init({
        apiKey: 'AIzaSyDKYa7SPum5A40UuGiXkcMuFLYAoAp7MNw',
        discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
    });
    if (window.gapi.client.getToken()) {
        return;
    }
    await new Promise((resolve) => {
        const tokenClient = window.google.accounts.oauth2.initTokenClient({
            client_id: '139541679371-ssqhd46lkdcknrr80ok9f53dm9dk2rhs.apps.googleusercontent.com',
            scope: "https://www.googleapis.com/auth/spreadsheets.readonly",
            callback: resolve,
        });
        window.alert('Sign in with Google to fetch localization sheet in order to display localization keys.');
        tokenClient.requestAccessToken();
    });
}

/**
 * @typedef GoogleUser
 */

export class GoogleAuth {
    /**
     * @returns {Promise<GoogleUser>}
     */
    static get() {
        if (!GoogleAuth.result) {
            GoogleAuth.result = getGoogleAuth();
        }
        return GoogleAuth.result;
    }
}
